export default "__VITE_ASSET__DPT$dzYY__"